import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { Link, withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';

import { saveReference, updateReference } from './actions';
import TextField from '../../components/common/TextField';
import SelectField from '../../components/common/SelectField';
import DropNCropField from '../../components/common/DropNCropField';
import { REFERENCE_FORM_NAME } from './constants';

const required = value => (value ? undefined : 'Povinný údaj');

class ReferenceForm extends Component {
  onSubmit = formProps => {
    const { lang } = formProps;
    const { config } = this.props;

    const referenceRequestData = {
      title: formProps.title,
      subtitle: formProps.subtitle,
      content: 'empty',
      header: formProps.header,
      headerImage: formProps.headerImage.result
    };

    if (config && config.id) {
      // add new mutation for existing reference
      this.props.updateReference(referenceRequestData, config.id, lang, () => {
        this.props.history.push('/reference');
      });
    } else {
      // create brand new reference
      this.props.saveReference(referenceRequestData, lang, () => {
        this.props.history.push('/reference');
      });
    }
  };

  render() {
    const { config } = this.props;
    const { handleSubmit } = this.props;

    return (
      <div className="new-reference">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            key="lang"
            component={SelectField}
            label="Jazyk"
            name="lang"
            disabled={config ? config.disableSelect : false}
            validate={required}
          >
            <option value="" key="empty">
              Vyberte jazyk
            </option>
            <option value="cs" key="cs">
              CZ
            </option>
            <option value="en" key="en">
              EN
            </option>
          </Field>
          <Field
            component={TextField}
            type="text"
            label="Nadpis"
            name="header"
            validate={required}
          />
          <Field
            component={TextField}
            type="textarea"
            label="Text"
            name="subtitle"
            validate={required}
          />
          <Field
            component={DropNCropField}
            label="Obrázek"
            name="headerImage"
            validate={required}
            minCropBoxWidth={588}
            aspectRatio={16 / 9}
          />
          <div className="form-buttons">
            <Button color="primary">Uložit</Button>
            <Button tag={Link} to="/reference" color="danger">
              Zpět na reference
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = {
  saveReference,
  updateReference
};

export default compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps
  ),
  reduxForm({ form: REFERENCE_FORM_NAME })
)(ReferenceForm);



// WEBPACK FOOTER //
// ./src/modules/ReferenceForm/index.js